/**
 * Homepage Highlighting Configuration
 *
 * Centralized configuration for highlighting specific words/phrases
 * on the homepage (search section).
 */

import { renderHighlightedTitle } from "./highlightUtils";

// Utility function to render the homepage main heading with highlighting
// This function now receives translated text from the component
export const renderHomepageMainHeading = (
  innovationTextClasses,
  firstLinePrefix,
  firstLineHighlight,
  secondLinePrefix,
  secondLineHighlight,
) => {
  const config = {
    firstLine: {
      prefix: firstLinePrefix,
      highlight: firstLineHighlight,
      suffix: "",
    },
    secondLine: {
      prefix: secondLinePrefix,
      highlight: secondLineHighlight,
      suffix: "",
    },
  };

  return (
    <>
      {renderHighlightedTitle(
        config.firstLine,
        innovationTextClasses,
        `${firstLinePrefix} ${firstLineHighlight}`,
      )}
      <br />
      <span className="block mt-6">
        {renderHighlightedTitle(
          config.secondLine,
          innovationTextClasses,
          `${secondLinePrefix} ${secondLineHighlight}`,
        )}
      </span>
    </>
  );
};

export default renderHomepageMainHeading;
